import React from "react";
import Head from "next/head";
import funnel from "../styles/Funnel.module.css";
import { styled } from "@mui/material/styles";
import axios from "axios";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { NumericFormat } from "react-number-format";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Footer from "../component/footer";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

const GetCosdeButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "55px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  padding: "3px",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

let CustomSelect = styled(Select)(() => ({
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
}));

let CustomSelectPhone = styled(Select)(() => ({
  "&.MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
}));

const SubmitBtn = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "45px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  padding: "3px",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

export default function ContactUs() {
  const [formData, setFormData] = React.useState({
    fname: "",
    lname: "",
    email: "",
    email_otp: "",
    contry_code: "",
    phone: "",
    support: "",
    text: "",
  });
  const [loading, setLoading] = React.useState(false);
  const [otpBox, setOtpBox] = React.useState(false);
  const [resend, setResend] = React.useState(false);
  const [disableAuto, setDisableAuto] = React.useState("");
  const [errorSubmit, setErrorSubmit] = React.useState({
    fname: false,
    lname: false,
    email: false,
    email_otp: false,
    support: false,
    text: false,
  });
  const [isError, setIsError] = React.useState(false);
  const [isSuccess, setSuccess] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [token, setToken] = React.useState(null);
  const router = useRouter();

  const handleChangeFname = (event) => {
    setFormData({
      ...formData,
      fname: event.target.value,
    });
    setErrorSubmit({
      ...errorSubmit,
      fname: false,
    });
  };

  let fnameError;
  let helperTextFname;
  if (errorSubmit.fname == true) {
    fnameError = "error";
    helperTextFname = "Your name is required and enter the format correctly!";
  } else {
    fnameError = "";
    helperTextFname = "";
  }

  const handleChangeLname = (event) => {
    setFormData({
      ...formData,
      lname: event.target.value,
    });
    setErrorSubmit({
      ...errorSubmit,
      lname: false,
    });
  };

  let lnameError;
  let helperTextLname;
  if (errorSubmit.lname == true) {
    lnameError = "error";
    helperTextLname =
      "Your last name is required and enter the format correctly!";
  } else {
    lnameError = "";
    helperTextLname = "";
  }

  const handleChangeemail = (event) => {
    setFormData({
      ...formData,
      email: event.target.value,
    });
    setErrorSubmit({
      ...errorSubmit,
      email: false,
    });
  };

  const getOtpcode = (e) => {
    e.preventDefault();
    if (
      formData.email === "" ||
      formData.email.length <= 7 ||
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      return setErrorSubmit({
        ...errorSubmit,
        email: true,
      });
    } else {
      setLoading(true);
      setIsError(false);
      setSuccess(false);
      erroremail = "";
      helperTextEmail = "";
      const data = {
        email: formData.email,
      };
      axios
        .post(`${process.env.NEXT_PUBLIC_API_BASE_URL}/contact/otp/`, data)
        .then((res) => {
          setLoading(false);
          setOtpBox(true);
          setIsError(false);
          setDisableAuto("disabled");
          setTimeout(() => setSuccess(false), 3000);
          setTimeout(() => setResend(true), 600000);
        })
        .catch((err) => {
          setLoading(false);
          setOtpBox(false);
          setIsError(true);
          setMessage(err.response.data.detail);
          setTimeout(() => setIsError(false), 5000);
          if (err.code == "ERR_NETWORK") {
            router.push("/error/");
          }
        });
    }
  };

  let erroremail;
  let helperTextEmail;
  if (errorSubmit.email == true) {
    erroremail = "error";
    helperTextEmail = "The email is required and enter the format correctly!";
  } else {
    erroremail = "";
    helperTextEmail = "";
  }

  const handleChangeOtp = (event) => {
    setFormData({
      ...formData,
      email_otp: event.target.value,
    });
    setErrorSubmit({
      ...errorSubmit,
      email_otp: false,
    });
  };

  const editButton = () => {
    setDisableAuto("");
  };

  let errorOtp;
  let helperTextOtp;
  if (errorSubmit.email_otp == true) {
    errorOtp = "error";
    helperTextOtp = "Otp cannot be empty!";
  } else {
    errorOtp = "";
    helperTextOtp = "";
  }

  const handleChangeSelect = (event) => {
    setFormData({ ...formData, support: event.target.value });
    setErrorSubmit({
      ...errorSubmit,
      support: false,
    });
  };

  const handleChangeContryCode = (event) => {
    setFormData({ ...formData, contry_code: event.target.value });
  };

  const handleChangephone = (event) => {
    setFormData({
      ...formData,
      phone: event.target.value,
    });
  };

  let helperTextSupport;
  if (formData.support == true) {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "red",
        },
        "&:hover fieldset": {
          borderColor: "red",
        },
        "&.Mui-focused fieldset": {
          borderColor: "red",
        },
      },
    }));
    helperTextSupport = "Please select a option!";
  } else {
    CustomSelect = styled(Select)(() => ({
      "&.MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#cacaca",
        },
        "&:hover fieldset": {
          borderColor: "var(--primary-color)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "var(--primary-color)",
        },
      },
    }));
    helperTextSupport = "";
  }

  const handleChangeText = (event) => {
    setFormData({
      ...formData,
      text: event.target.value,
    });
    setErrorSubmit({
      ...errorSubmit,
      text: false,
    });
  };

  let textError;
  let helperText;
  if (errorSubmit.text == true) {
    textError = "error";
    helperText = "The Text is required and enter the format correctly!";
  } else {
    textError = "";
    helperText = "";
  }

  const handleSubmit = () => {
    // /^[A-Za-z ]+$/
    if (
      formData.fname === "" ||
      formData.fname.length <= 0 ||
      !/^[A-Za-z ]+$/i.test(formData.fname)
    ) {
      setErrorSubmit({
        ...errorSubmit,
        fname: true,
      });
    } else if (
      formData.lname === "" ||
      formData.lname.length <= 0 ||
      !/^[A-Za-z ]+$/i.test(formData.lname)
    ) {
      setErrorSubmit({
        ...errorSubmit,
        lname: true,
      });
    } else if (
      formData.email === "" ||
      formData.email.length <= 7 ||
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      setErrorSubmit({
        ...errorSubmit,
        email: true,
      });
    } else if (formData.email_otp === "" || formData.email_otp.length <= 0) {
      setErrorSubmit({
        ...errorSubmit,
        email_otp: true,
      });
    } else if (formData.support === null) {
      setErrorSubmit({
        ...errorSubmit,
        support: true,
      });
    } else if (
      formData.text === "" ||
      formData.text.length <= 0 ||
      !/^[A-Za-z0-9 ]+$/i.test(formData.text)
    ) {
      setErrorSubmit({
        ...errorSubmit,
        text: true,
      });
    } else if (
      errorSubmit.fname == false &&
      errorSubmit.lname == false &&
      errorSubmit.email == false &&
      errorSubmit.email_otp == false &&
      errorSubmit.support == false &&
      errorSubmit.text == false
    ) {
      setErrorSubmit({
        ...errorSubmit,
        fname: false,
        lname: false,
        email: false,
        email_otp: false,
        support: false,
        text: false,
      });
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute("6LfBDMwkAAAAAMpjJ5Qgh6YLotaoJtnI1DN2Ul4H", {
            action: "submit",
          })
          .then((token) => {
            setToken(token);
            const data = {
              firstname: formData.fname,
              lastname: formData.lname,
              email: formData.email,
              phone_number: formData.phone,
              phone_number_country_code: formData.contry_code,
              otp: formData.email_otp,
              role: formData.support,
              comment: formData.text,
              captcha: token,
            };

            axios
              .post(`${process.env.NEXT_PUBLIC_API_BASE_URL}/contact/`, data)
              .then((res) => {
                setOpen(true);
              })
              .catch((err) => {
                setOpenAlert(true);
                if (err.code == "ERR_NETWORK") {
                  router.push("/error/");
                }
              });
          });
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert(false);
  };

  return (
    <>
      <Head>
        <title>Contact Us</title>
        <link rel="canonical" href="https://abodefinder.com.au/contact/"></link>
        <meta property="og:title" content="Contact Us" />
        <meta
          property="og:url"
          content="https://abodefinder.com.au/contact-us/"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>

        <script
          src="https://www.google.com/recaptcha/api.js?render=6LfBDMwkAAAAAMpjJ5Qgh6YLotaoJtnI1DN2Ul4H"
          async
        ></script>
      </Head>
      <div className={funnel.allFunnel}>
        <div className={funnel.funnelContact}>
          <div className={funnel.funnelBody} style={{ marginTop: "40px" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className={funnel.contactUs}>
                <Typography
                  sx={{ textAlign: "center", mb: 7 }}
                  variant="h4"
                  gutterBottom
                >
                  Contact Us
                </Typography>
                <FormControl fullWidth>
                  <CssTextField
                    id="outlined-basic"
                    label="Your name"
                    error={fnameError}
                    helperText={helperTextFname}
                    onChange={handleChangeFname}
                    variant="outlined"
                    sx={{ mt: 2, mb: 2 }}
                  />
                  <CssTextField
                    id="outlined-basic"
                    label="Your last name"
                    error={lnameError}
                    helperText={helperTextLname}
                    onChange={handleChangeLname}
                    variant="outlined"
                    sx={{ mt: 2, mb: 2 }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <Box
                      sx={(theme) => ({
                        display: "flex",
                        flexDirection: "row",
                        mb: 2,
                        alignItems: "flex-start",
                        [theme.breakpoints.down("sm")]: {
                          flexDirection: "column",
                          mb: 2,
                          alignItems: "flex-start",
                        },
                      })}
                    >
                      <CssTextField
                        id="email"
                        name="email"
                        label="Email"
                        disabled={disableAuto}
                        onChange={handleChangeemail}
                        error={erroremail}
                        helperText={helperTextEmail}
                        customInput={CssTextField}
                        sx={(theme) => ({
                          width: "75%",
                          [theme.breakpoints.down("sm")]: {
                            width: "100%",
                            mb: 1,
                          },
                        })}
                      />
                      <GetCosdeButton
                        variant="contained"
                        onClick={getOtpcode}
                        sx={(theme) => ({
                          width: "25%",
                          ml: 0.6,
                          [theme.breakpoints.down("sm")]: {
                            width: "100%",
                            height: "38px",
                            ml: 0,
                            mb: 1,
                          },
                        })}
                        disabled={disableAuto}
                      >
                        {loading ? "Loading..." : "Get code"}
                      </GetCosdeButton>
                    </Box>
                    {otpBox && (
                      <Box>
                        <NumericFormat
                          error={errorOtp}
                          helperText={helperTextOtp}
                          name="otp"
                          placeholder="_ _ _ _ _"
                          onChange={handleChangeOtp}
                          id="outlined-adornment-amount"
                          customInput={CssTextField}
                          sx={{ width: "100%" }}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Button
                            sx={{
                              color: "var(--primary-color)",
                              textTransform: "none",
                            }}
                            onClick={editButton}
                          >
                            Edit Email
                          </Button>
                          {resend && (
                            <Button
                              sx={{
                                color: "var(--primary-color)",
                                textTransform: "none",
                              }}
                              onClick={getOtpcode}
                            >
                              Resend Code
                            </Button>
                          )}
                        </Box>
                      </Box>
                    )}
                  </div>

                  <Box
                    sx={(theme) => ({
                      display: "flex",
                      flexDirection: "row",
                      mb: 2,
                      alignItems: "flex-start",
                      [theme.breakpoints.down("sm")]: {
                        flexDirection: "column",
                        mb: 2,
                        alignItems: "flex-start",
                      },
                    })}
                  >
                    <FormControl
                      sx={(theme) => ({
                        width: "20%",
                        mr: 0.6,
                        [theme.breakpoints.down("sm")]: {
                          width: "100%",
                          mr: 0,
                          mb: 1,
                        },
                      })}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Contry code
                      </InputLabel>
                      <CustomSelectPhone
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Contry code"
                        value={formData.contry_code}
                        onChange={handleChangeContryCode}
                      >
                        <MenuItem value={61}>(+61)</MenuItem>
                        <MenuItem value={1}>(+1)</MenuItem>
                        <MenuItem value={64}>(+64)</MenuItem>
                        <MenuItem value={44}>(+44)</MenuItem>
                        <MenuItem value={65}>(+65)</MenuItem>
                        <MenuItem value={852}>(+852)</MenuItem>
                        <MenuItem value={81}>(+81)</MenuItem>
                        <MenuItem value={91}>(+91)</MenuItem>
                        <MenuItem value={86}>(+86)</MenuItem>
                        <MenuItem value={60}>(+60)</MenuItem>
                      </CustomSelectPhone>
                    </FormControl>
                    <NumericFormat
                      name="phone"
                      placeholder="0000000"
                      onChange={handleChangephone}
                      id="outlined-adornment-amount"
                      customInput={CssTextField}
                      sx={(theme) => ({
                        width: "85%",
                        [theme.breakpoints.down("sm")]: {
                          width: "100%",
                          mb: 1,
                        },
                      })}
                    />
                  </Box>
                </FormControl>
                <FormControl
                  sx={(theme) => ({
                    width: "100%",
                    mt: 2,
                    mb: 2,
                    [theme.breakpoints.down("sm")]: {
                      width: "100%",
                      mr: 0,
                      mb: 1,
                    },
                  })}
                >
                  <InputLabel id="demo-simple-select-label">
                    Choose...
                  </InputLabel>
                  <CustomSelect
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Choose..."
                    value={formData.support}
                    onChange={handleChangeSelect}
                    helperText={helperTextSupport}
                  >
                    <MenuItem value="Login Assistance">
                      Login Assistance
                    </MenuItem>
                    <MenuItem value="General Support">General Support</MenuItem>
                    <MenuItem value="Partnership">Partnership</MenuItem>
                  </CustomSelect>
                </FormControl>
                <FormControl fullWidth>
                  <CssTextField
                    id="outlined-multiline-static"
                    label="Write something"
                    multiline
                    rows={5}
                    sx={{ mt: 2, mb: 2, width: "100%" }}
                    error={textError}
                    helperText={helperText}
                    onChange={handleChangeText}
                  />
                </FormControl>
              </div>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                mt: 2,
              }}
            >
              <SubmitBtn variant="contained" onClick={handleSubmit}>
                Submit
              </SubmitBtn>
            </Box>
          </div>
        </div>
      </div>
      <Footer />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={(theme) => ({
            width: "600px",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: { width: "280px" },
          })}
        >
          <Typography
            variant="subtitle1"
            style={{ color: "green" }}
            gutterBottom
          >
            THANK YOU!
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            Your message received
          </Typography>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="error"
          sx={{ width: "100%" }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Error
          </Typography>
        </Alert>
      </Snackbar>
    </>
  );
}
